module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/ja/2-73aae93b40fa99c5ea293936e433ffed.jpg";